import { AnyAction } from 'redux'
import initialState from './initialState'
import { SettingsState, SettingsActionTypes } from './types'

export default function settingsReducer(
  state = initialState,
  action: AnyAction
): SettingsState {
  switch (action.type) {
    case SettingsActionTypes.FETCH_SETTINGS_PENDING: {
      return {
        ...state,
        isLoading: true
      }
    }
    case SettingsActionTypes.FETCH_SETTINGS_FULFILLED: {
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: undefined
      }
    }
    case SettingsActionTypes.FETCH_SETTINGS_REJECTED: {
      return {
        ...state,
        isLoading: false,
        error: action.payload
      }
    }
    case SettingsActionTypes.LOGOUT: {
      return { ...initialState, data: {} }
    }
    default:
      return state
  }
}
